<template>
  <tr style="padding: 0px;">
    <td style="text-align: center;padding: 0px;"> {{ row.idx + 1 }}</td>

    <td  style="padding: 0px;width: 60px;">
      <input type="number" class="form-control" v-model="row.fabric_id" @keyup.enter="loadFabric(row.fabric_id)"/>
    </td>
    <td style="padding: 0px;">
      <button class="btn btn-outline-success" @click="loadFabric(row.fabric_id)" tabindex="-1" >Find</button>
    </td>
    <td style="padding: 0px;">
      {{ row.fabric.quality.name }}
    </td>
    <td style="padding: 0px;">
      {{ row.fabric.color.name }}
    </td>
    <td style="padding: 0px;text-align: right;padding-right: 20px;">
      {{row.fab_weight | weightFormat}}
    </td>
    <td style="padding: 0px;text-align: right;width: 60px;">
      <input type="number" class="form-control text-right" v-if="row" v-model="row.stentering_qc_damages" @change="rowValueEqualizer(6)" />
    </td>

    <td style="padding: 0px;text-align: right">
      <button name="btnRemoveRow"   type="button" class="btn border-warning text-warning-600 btn-flat btn-icon btn-rounded legitRipple btnRemoveRow" @click="removeRow(index)" tabindex="-1" ><i class="icon-eraser"></i></button>
    </td>

  </tr>
</template>

<script>
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'StenteringQcDetailRow',
    props: {
      myrow: {
        type: Object,
        default: () => JSON.parse('{"idx":0,"id":0,"master_id":0,"fabric_id":0,"item_id":0,"stentering_damages":0,"fab_weight":0,"weight":0,"stentering_qc_damages":0,"fabric":{"id":0,"cmp_id":0,"shift_id":0,"mac_id":0,"emp_id":0,"item_id":0,"qua_id":0,"col_id":0,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_id":0,"stentering_damages":0,"stentering_qc_id":0,"stentering_qc_damages":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""}}}')
      },
      myindex: {
        type: Number,
        default: () => 0
      }
    },
    beforeMount () {
      this.row = this.myrow;
      this.index = this.myindex;
      this.row.idx = this.myindex;
    },
    data () {
      return {
        index: 0,
        row : JSON.parse('{"idx":0,"id":0,"master_id":0,"fabric_id":0,"item_id":0,"stentering_damages":0,"fab_weight":0,"weight":0,"stentering_qc_damages":0,"fabric":{"id":0,"cmp_id":0,"shift_id":0,"mac_id":0,"emp_id":0,"item_id":0,"qua_id":0,"col_id":0,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_id":0,"stentering_damages":0,"stentering_qc_id":0,"stentering_qc_damages":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""}}}')
      }
    },
    filters:{
      weightFormat (val){
        try {
          return val.toFixed(3);
        }catch (e) {

        }
        return val;
      }
    },
    methods:{
      removeRow(){
        this.$emit('onRemoveRow', Math.abs(this.row.idx) );
      },
      rowValueEqualizer(col) {
        const self = this;
        try {

          let receipt = self.receipt;

          switch (col) {
            case 1: //Fab Code
              break;
            case 2: //Fab Button
              break;
            case 3: //Quality
              break;
            case 4: //Color
              break;
            case 5:  //Weight
              break;
            case 6: //Damage
              self.row.stentering_qc_damages = parseFloat(self.row.stentering_qc_damages);
              self.$emit('on_value_change', self.myindex, 6, self.row.stentering_qc_damages);

              break;
          }
        }catch (e) {

        }

      },
      loadFabric(id){
        if(id < 1) {
          return;
        }

        $('tr').block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.row = JSON.parse('{"idx":0,"id":0,"master_id":0,"fabric_id":0,"item_id":0,"stentering_damages":0,"fab_weight":0,"weight":0,"stentering_qc_damages":0,"fabric":{"id":0,"cmp_id":0,"shift_id":0,"mac_id":0,"emp_id":0,"item_id":0,"qua_id":0,"col_id":0,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_id":0,"stentering_damages":0,"stentering_qc_id":0,"stentering_qc_damages":0,"quality":{"id":0,"name":""},"color":{"id":0,"name":""}}}');
        self.$data.row.idx = self.myindex ;

        fetch(`${process.env.VUE_APP_ROOT_API}api/knitting/receipt/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {

            if(!_.isNull(resp.data)){
              // console.log(JSON.stringify(resp.data));
              self.$data.row.fabric_id = resp.data.id;
              self.$data.row.item_id = resp.data.item_id;
              self.$data.row.fabric = resp.data;
              self.$data.row.fab_weight = resp.data.fab_weight;
              self.$data.row.idx = self.myindex;
              self.showmsg(1);
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(function () {
          $('tr').unblock();
        });
      },
      showmsg(colIndex){

        switch (colIndex) {
          case 1:
            this.$emit('onrow_change', this.index, colIndex, this.row);
            break;
          case 6:
            this.$emit('onrow_change', this.index, colIndex, this.row.stentering_qc_damages);
            break;

        }

        //alert(this.fabric.needle_damages);
      },
    }
  }
</script>

<style scoped>

</style>
